import { Vue, Component } from 'vue-property-decorator'
import PageHeader from '~/components/page/PageHeader'
import LinkItem from '~/types/LinkItem'
import HeaderType from '~/types/enum/HeaderType'
import ProductBasket from '~/components/element/ProductBasket'
import BasketResult from '~/components/page/basket/BasketResult'
import BasketPrescriptionSvg from '~/assets/svg/basket-prescription.svg?inline'
import loc from '~/utils/loc'
import BasketNotFoundPage from '~/components/page/basket/BasketNotFoundPage'
import BasketWaitingListEmpty from '~/components/page/basket/BasketWaitingListEmpty'
import s from '~/utils/s'
import ProductSlides from '~/components/block/ProductSlides'
import PartnerCardBlock from '~/components/block/PartnerCardBlock'
import mainBreadcrumbsSubmenuItems from '~/utils/mainBreadcrumbsSubmenuItems'
import { Sections } from '~/types/enum/Sections'
import AD_FOX_CONSTANTS from '~/types/enum/AdFoxEnum'
import checkIframes from '~/components/setStylesForAddBanners'

@Component
export default class BasketPage extends Vue {
  isShowPrescription: boolean = true
  isShowBasketTab: boolean = true
  showSlider?: Boolean = true

  beforeMount () {
    this.validateSlider()
  }

  async mounted () {
    await s(this.$store).basket.fillData()
    await s(this.$store).basket.fillSlidersData()
    await s(this.$store).waitingList.fillData()
    await s(this.$store).advertising.addInfoInContainer(AD_FOX_CONSTANTS.inBasket)

    setInterval(checkIframes, 500)
  }

  get breadcrumb (): LinkItem[] {
    return [
      {
        title: 'Главная',
        location: loc(this.$store, { name: 'index' }),
        submenuItems: mainBreadcrumbsSubmenuItems(this.$store)
      },
      {
        title: 'Корзина',
        location: loc(this.$store, { name: 'basket' })
      }
    ]
  }

  get isPrescription () {
    return !!s(this.$store).basket.items.find(e => e.product.byPrescription)
  }

  get isVeterinary () {
    return !!s(this.$store).basket.items.find(e => e.product.isVeterinary)
  }

  get isHaveProducts () {
    return s(this.$store).basket.items.length > 0
  }

  get isShowPartnerCardBlock (): boolean {
    return s(this.$store).partnerCardBlock.partnerCards.length > 0
  }

  get isShowBasket (): boolean {
    return this.isShowBasketTab
  }

  validateSlider () {
    if (s(this.$store).regions.section?.code === Sections.eCertificate) {
      this.showSlider = false
    } else {
      this.showSlider = true
    }
  }

  renderViewedProducts () {
    if (s(this.$store).categoryPage.viewedProducts.count > 0) {
      return (
        <div class="basket-page__viewed">
          <ProductSlides {...{
            props: {
              products: s(this.$store).categoryPage.viewedProducts.items,
              title: 'Недавно просмотренные товары',
              isShowButton: false
            }
          }} />
        </div>
      )
    }
  }

  renderRecommendations () {
    if (s(this.$store).basket.recommendations.length > 0) {
      return (
        <div class="basket-page__recommendations">
          <ProductSlides
            {...{
              props: {
                products: s(this.$store).basket.recommendations,
                title: 'Вам может пригодиться',
                isShowButton: false
              }
            }}
          />
        </div>
      )
    }
  }

  renderPartnerCardBlock () {
    if (this.isShowPartnerCardBlock) {
      return (
        <div class="basket-page__col-partner-card">
          <PartnerCardBlock {...{
            props: {
              items: s(this.$store).partnerCardBlock.partnerCards
            }
          }} />
        </div>
      )
    }
  }

  renderAdvertising () {
    return (
      <div class = "basket-page__col-partner-card adfox" id={AD_FOX_CONSTANTS.inBasket}>
      </div>
    )
  }

  renderDeliveryNotification () {
    const types = []

    if (this.isPrescription) { types.push('рецептурные') }
    // if (this.isVeterinary) { types.push('ветеринарные') }

    if (this.isPrescription) {
      let typesString = types.join(' и ')
      typesString = typesString[0].toUpperCase() + typesString.slice(1)

      return (
        <div class="basket-page__prescription">
          <div class="basket-page__prescription-icon">
            <BasketPrescriptionSvg />
          </div>
          <div class="basket-page__prescription-text">
            { typesString } препараты доставляются только до пункта самовывоза.
          </div>
        </div>
      )
    }
  }

  renderContent () {
    return (
      <div class="basket-page__content">
        <div class="basket-page__row">
          <div class="basket-page__col-list">
            <div class="basket-page__tab-nav">
              <div {...{
                class: {
                  'basket-page__tab-link': true,
                  'basket-page__tab-link_active': this.isShowBasket
                },
                on: {
                  click: () => { this.isShowBasketTab = true }
                }
              }}>
                В корзине
                {s(this.$store).basket.items.length > 0 &&
                <div class="basket-page__tab-link-exist"></div>
                }
                <div class="basket-page__tab-link-selected"></div>
              </div>
              <div {...{
                class: {
                  'basket-page__tab-link': true,
                  'basket-page__tab-link_active': !this.isShowBasket
                },
                on: {
                  click: (event: MouseEvent) => {
                    /* const { isAuth } = s(this.$store).auth
                    if (!isAuth) {
                      event.stopPropagation()
                      s(this.$store).general.showPopup('AuthPopup')
                    } else {
                      this.isShowBasketTab = false
                    } */
                    this.isShowBasketTab = false
                  }
                }
              }}>
                Лист ожидания
                {s(this.$store).waitingList.items.length > 0 &&
                  <div class="basket-page__tab-link-exist"></div>
                }
                <div class="basket-page__tab-link-selected"></div>
              </div>
            </div>
            {this.isShowBasket &&
            <div class="basket-page__tab basket-page__tab-basket">
              {!this.isHaveProducts ? <BasketNotFoundPage/>
                : this.isShowPrescription && this.renderDeliveryNotification()}
              {this.isHaveProducts &&
              <div class="basket-page__list">
                {s(this.$store).basket.items.map(e => (
                  <div key={e.id} class="basket-page__item">
                    <ProductBasket {...{
                      props: {
                        cartItem: e
                      }
                    }} />
                  </div>
                ))}
              </div>
              }
            </div>
            }
            {!this.isShowBasket &&
            <div class="basket-page__tab basket-page__tab-waiting-list">
              {s(this.$store).waitingList.items.length > 0 &&
              <div class="basket-page__list">
                <div class="basket-page__list">
                  {s(this.$store).waitingList.items.map(e => (
                    <div key={e.id} class="basket-page__item">
                      <ProductBasket {...{
                        props: {
                          cartItem: e,
                          inWaitingList: true
                        }
                      }} />
                    </div>
                  ))}
                </div>
              </div>
              }
              {s(this.$store).waitingList.items.length < 1 &&
              <BasketWaitingListEmpty />
              }
            </div>
            }
            {this.isShowPartnerCardBlock &&
            <div class="basket-page__partner-card_in-list">
              {this.renderPartnerCardBlock()}
            </div>
            }
          </div>
          <div class="basket-page__col-result">
            <BasketResult />
          </div>
          {this.isShowPartnerCardBlock &&
          <div class="basket-page__partner-card_in-basket">
            {this.renderPartnerCardBlock()}
          </div>
          }
          {s(this.$store).advertising.isActive && this.renderAdvertising()}
        </div>
        {this.isHaveProducts ? this.renderRecommendations() : this.renderViewedProducts() }
      </div>
    )
  }

  renderPopularSlider () {
    if ((s(this.$store).basket.popularProducts.length > 0) && (this.showSlider)) {
      return (
        <div class="basket-page__popular-slider">
          <ProductSlides
            {...{
              props: {
                products: s(this.$store).basket.popularProducts,
                title: 'Популярные товары',
                location: loc(this.$store, {
                  name: 'catalog-popular'
                }
                ),
                isShowButton: true
              }
            }}
          />
        </div>
      )
    }
  }

  renderWishlistSlider () {
    if ((s(this.$store).basket.favoriteProducts.length > 0) && (this.showSlider)) {
      return (
        <div class="basket-page__wishlist-slider">
          <ProductSlides {...{
            props: {
              title: 'Избранное',
              products: s(this.$store).basket.favoriteProducts.slice(0, 20),
              isShowButton: true,
              location: loc(this.$store, {
                name: 'wishlist'
              }
              )
            }
          }}/>
        </div>
      )
    }
  }


  render () {
    return (
      <div class="basket-page">
        <div class="basket-page__header">
          <PageHeader {...{
            props: {
              typeHeader: HeaderType.Basket,
              breadcrumb: this.breadcrumb,
              isShowBasketClearButtons: this.isShowBasketTab
            }
          }} />
        </div>
        {this.renderContent()}
        {this.renderPopularSlider()}
        {this.renderWishlistSlider()}
      </div>
    )
  }
}

